//import React from 'react';
// 3) HELMET - Add this import to each page
import React, { Fragment, useRef, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { SplitText } from "gsap/SplitText";
import { DrawSVGPlugin } from '../js/DrawSVGPlugin.js'; // Import the JavaScript file
import { MotionPathPlugin} from '../js/MotionPathPlugin.js'; // Import the JavaScript file
import { Physics2DPlugin} from '../js/Physics2DPlugin.min.js'; // Import the JavaScript file
import { InertiaPlugin} from '../js/InertiaPlugin.min.js'; // Import the JavaScript file

import { NavLink } from 'react-router-dom';



import heroimg_services from '../images/heros/services.webp'; // Tell webpack this JS file uses this image



import services_img_1 from '../images/services/services-page-web-development.webp'; 
import lightbulb_1_back from '../images/services/hero-lightbulb-1-back.webp'; 
import lightbulb_1_front from '../images/services/hero-lightbulb-1-front.webp'; 
import lightbulb_1_light from '../images/services/lighthouse-light-glare.webp'; 
import lightbulb_2_back from '../images/services/hero-lightbulb-2-back.webp'; 
import lightbulb_2_front from '../images/services/hero-lightbulb-2-front.webp'; 
import lightbulb_3_back from '../images/services/hero-lightbulb-3-back.webp'; 
import lightbulb_3_front from '../images/services/hero-lightbulb-3-front.webp'; 
import services_quote_icon from '../images/icons/icon-estimate.svg'; 
import graphic_design_section_bg from '../images/services/graphic-design-twirl-bg.webp'; 
import beach_ball from '../images/services/beach-ball.svg';



// SCROLLING ANIMATION
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(InertiaPlugin);
gsap.registerPlugin(Physics2DPlugin);




const Services = () => {

  const bgfx_ref_5 = useRef();



useGSAP(() => {

    //Presets
    gsap.set(".services-transition-curtain", {left:"-4000", top:"-4000"});
 


 // =============================================== //
// HERO ANIMATION
// =============================================== //
// presets
gsap.set("#arrow-wheel-1", {y: "40px"});
gsap.set("#arrow-wheel-2", {y: "-50px", x:"30px"});
gsap.set("#arrow-wheel-3", {y: "-30px", x:"-30px"});


// HERO  - ARROW CIRCLE FX
let tlarrowfx = gsap.timeline({repeat:-1, delay:5});

tlarrowfx
.to("#arrow-wheel-1", {duration:10, rotateZ: 360,  transformOrigin:"center center", ease: "none"})
.to("#arrow-wheel-2", {duration:10, rotateZ: 360,  transformOrigin:"center center", ease: "none", delay:-10})
.to("#arrow-wheel-3", {duration:10, rotateZ: -360,  transformOrigin:"center center", ease: "none", delay:-10})

// HERO - DIGITAL TYPE EFFECT
// ================================ //
 let text1;
 let text2;
 let text3;

 let typingText1 = document.getElementById("typing-text-1");
 let typingText2 = document.getElementById("typing-text-2");
 let typingText3 = document.getElementById("typing-text-3");	
	
 let index1 = 0;
 let index2 = 0;
 let index3 = 0;	
	
function typefx_1() {
  text1 = "Websites built with conversion driven designs that are fully scalable with no limitations";
  if (index1 < text1.length) {
    typingText1.textContent += text1.charAt(index1);
    index1++;
    setTimeout(typefx_1, 10);
  }
}
function typefx_2() {
  text2 = "Specializing in unique marketing designs that strongly brand your business and attract more customers.";
  if (index2 < text2.length) {
    typingText2.textContent += text2.charAt(index2);
    index2++;
    setTimeout(typefx_2, 10); 
  }
}
function typefx_3() {
  text3 = "Whether you just want something simple or something complex, I have the expertise to shape your WordPress website anyway you'd like it. Get it done right with a professional WordPress website.";
  if (index3 < text3.length) {
    typingText3.textContent += text3.charAt(index3);
    index3++;
    setTimeout(typefx_3, 10); 
  }
}	
	
let tl_typerfx  = gsap.timeline({});

function resetTypeFX(){
  typingText1.textContent = "";
  typingText2.textContent = "";
  typingText3.textContent = "";
  startTypeFX();
}
function startTypeFX(){
  gsap.set("#cursorfx-1", {autoAlpha:1});
  gsap.set("#cursorfx-2", {autoAlpha:1});
  gsap.set("#cursorfx-3", {autoAlpha:1});
  index1 = 0;
  index2 = 0;
  index3 = 0;
  typefx_1();
  typefx_2();
  typefx_3();
  tl_typerfx.to("#cursorfx-3", {duration:5, onComplete:resetTypeFX});	
}
tl_typerfx.to("#cursorfx-3", {duration:1, onComplete:startTypeFX, delay:3.5});

// EOF HERO ANIMATIONS >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 

// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// HERO PLAY CONTROLLER 
//  When scrolled past 800 pixels pasies, resumes when scollred back
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
window.addEventListener('scroll', function() {

    if (window.scrollY > 300) {
      tlarrowfx.pause();        
      tl_typerfx.pause();    
    } else {
       tlarrowfx.play();        
      tl_typerfx.play();    
    }
       
});








  //Scroll Animation Trigger
    // ============================================= //
    //Presets
    gsap.set(".services-wd-image-wrap, .wd-ul-1 li, .wd-ul-2 li", {opacity:0});
    gsap.set(".wd-ul-1 li span, .gd-ul-1 li span", {x: "80px", opacity:0});
    gsap.set(".wd-ul-2 li span, .gd-ul-2 li span", {x: "80px", opacity:0});
    gsap.set(".wd-content h2", {x: "20px", opacity:0});
    gsap.set(".wd-content p", {y: "30px", opacity:0});

    // DYNAMIC DELAY VALUE
    const dynamicDelay = window.isInitialPreload ? 5 : 2;

// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //
//WEB DEVELOPMENT -  Content Animation
// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //

  let tl_wd_content  = gsap.timeline({
// Dynamic Dealy Value
  onComplete: () => {window.isInitialPreload = false;}
  });
     
 /* inital content on top of page to be shown */
  tl_wd_content
  .to(".wd-content h2", {duration:1, opacity: 1, x:"0px"}, `+=${dynamicDelay}`)
  .to(".wd-content p", {duration:1, opacity: 1, y:"0px"})
  .to(".services-wd-image-wrap", { opacity: 1, duration:1, delay:-1});

/* flag */
let listwd = false;
let wd_butn = document.querySelector(".button_services_list");
let wd_butn_label = document.querySelector(".button_label_wd");
let wd_arrow = document.querySelector(".button_services_arrow");

let tl_wd_content_list = gsap.timeline({
  scrollTrigger: {
    trigger: ".wd-content-2", 
    start: "top 80%",        
    toggleActions: "play none none none" 
  }
});

// Web Development Bullets
  tl_wd_content_list
  .to(".wd-ul-1 li", { opacity: 1, duration: 0.5, ease: "power2.out", stagger:0.15})
  .to(".wd-ul-1 li span", { opacity:1, x: "0px", duration: 0.5, ease: "power2.out", stagger:0.15, delay:"-1.25"})
  .to(".wd-ul-2 li", { opacity: 1, duration: 0.5, ease: "power2.out", stagger:0.15, delay:-0.5})
  .to(".wd-ul-2 li span", {opacity:1, x: "0px", duration: 0.5, ease: "power2.out", stagger:0.15, delay:"-1.25"});
   //.to(".services-wd-image-wrap", {duration:5, ease: "power2.out", backgroundPosition:360, delay:-4});

const target = document.querySelector(".services-wd-image-wrap");

window.addEventListener("mousemove", (e) => {
  // Calculate mouse position as a ratio between 0 and 1
  const mouseXRatio = e.clientX / window.innerWidth;
  const targetX = mouseXRatio * 100; 

  gsap.to(target, {
    duration: 1,           
    ease: "power2.out",
    backgroundPosition: `${targetX}% center`, 
    overwrite: "auto"      // Prevents animation glitches if the mouse moves fast
  });
});










// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //
// GRAPHIC DESIGN -  Content Animation
// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //

let gd_butn_label = document.querySelector(".button_label_gd");

gsap.set(".lightbulb-lighthouse, .lightbulb-city-ufo, .lightbulb-clock", {scale:0.5, opacity:0});
gsap.set(".graphic-design-services-bg, .gd-p1", {y:"40px", opacity:0});
gsap.set(".gd-ul-1 li, .gd-ul-2 li, .gd-ul-3 li", {opacity:0});

 // 1. Define the ScrollTrigger directly on the timeline configuration
let tl_gd_content = gsap.timeline({
  scrollTrigger: {
    trigger: ".gd-content-1",
    start: "top 80%", // Starts when the top of .gd-content-1 hits 80% of the viewport height
    toggleActions: "play none none none" // Plays once when entering
  }
});


tl_gd_content
  .to(".gd-p1", { opacity: 1, y: "0px", duration: 1})
  .to(".graphic-design-services-bg", { opacity: 1, y: "0px", duration: 1, ease: "power1.out", stagger: 0.25, delay:-1 })
  .to(".lightbulb-city-ufo", { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1,0.3)", stagger: 0.25, delay:-0.75})
  .to(".lightbulb-lighthouse", { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1,0.3)", stagger: 0.25, delay:-0.75 })
  .to(".lightbulb-clock", { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1,0.3)", stagger: 0.25, delay:-0.75 })
  .to(".graphic-design-services h2", { opacity: 1, x: "0px", duration: 1 });


let tl_gd_content_list = gsap.timeline({
  scrollTrigger: {
    trigger: ".gd-content-2", 
    start: "top 80%",         
    toggleActions: "play none none none" 
  }
});
  tl_gd_content_list.to(".gd-ul-1 li", { opacity: 1, duration: 0.5, ease: "power2.out", stagger:0.15})
  .to(".gd-ul-1 li span", { opacity:1, x: "0px", duration: 0.5, ease: "power2.out", stagger:0.15, delay:"-1.25"})
  .to(".gd-ul-2 li", { opacity: 1, duration: 0.5, ease: "power2.out", stagger:0.15, delay:-0.5})
  .to(".gd-ul-2 li span", {opacity:1, x: "0px", duration: 0.5, ease: "power2.out", stagger:0.15, delay:"-1.25"});




// TITLE ANIMATION TEXT FX
// --------------------------------------- //
// BLUR PLUGIN +++++
// https://codepen.io/GreenSock/pen/NWKjEBG?editors=0010
	const blurProperty = gsap.utils.checkPrefix("filter"),
		    blurExp = /blur\((.+)?px\)/,
		    getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

	gsap.registerPlugin({
		name: "blur",
		get(target) {
			return +(getBlurMatch(target)[1]) || 0;
		},
		init(target, endValue) {
			let data = this,
          filter = gsap.getProperty(target, blurProperty),
          endBlur = "blur(" + endValue + "px)",
          match = getBlurMatch(target)[0],
          index;
      if (filter === "none") {
        filter = "";
      }
      if (match) {
        index = filter.indexOf(match);
        endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
      } else {
        endValue = filter + endBlur;
        filter += filter ? " blur(0px)" : "blur(0px)";
      }
      data.target = target; 
      data.interp = gsap.utils.interpolate(filter, endValue); 
		},
		render(progress, data) {
			data.target.style[blurProperty] = data.interp(progress);
		}
	});



// ----------------------------------------- //
// Interactive Light Bulbs code
// --------------------------------------- //
  
// LIGHTHOUSE >>>>>>>>>>>>>>>>>>>

const lightbulb1 = document.querySelector('.lightbulb-lighthouse');
const light = lightbulb1.querySelector('.middle');

// Set initial states
gsap.set(light, { opacity: 0 });

// 1. Reusable pulse tween
const pulseAnimation = gsap.to(light, {
  opacity: 0.2,
  duration: 0.6,
  repeat: -1,
  yoyo: true,
  ease: "power1.inOut",
  paused: true
});

// 2. Main enter/leave timeline
const hoverTl = gsap.timeline({ paused: true })
  .to(lightbulb1, {
    scale: 1.2,
    duration: 0.5,
    ease: "power2.out"
  }, 0)
  .to(light, {
    opacity: 1,
    duration: 0.2,
    ease: "power2.out",
    onComplete: () => {
      // Start pulsing only if hovered
      if (lightbulb1.matches(':hover')) {
        pulseAnimation.restart();
      }
    }
  }, 0);

// Mouse Enter: Play hover timeline forward
lightbulb1.addEventListener('mouseenter', () => {
  hoverTl.play();
});

// Mouse Leave: Kill pulse & reverse the main timeline smoothly
lightbulb1.addEventListener('mouseleave', () => {
  // Gracefully stop the pulse loop
  pulseAnimation.pause();

  // Smoothly blend opacity back to where hoverTl expects it, then reverse
  gsap.to(light, {
    opacity: 1,
    duration: 0.15,
    onComplete: () => hoverTl.reverse()
  });
});

// CITY >>>>>>>>>>>>>>>>>>>

const container_bulb_3 = document.querySelector('.lightbulb-city-ufo');

// 1. Set transform origin for pivot points
gsap.set('.spotlight_1, .spotlight_2', { transformOrigin: 'center bottom' });

// 2. Animate both lights simultaneously in a single timeline
const spotlightTween = gsap.timeline({ paused: true, repeat: -1, yoyo: true })
  .to('.spotlight_1', { rotate: 15, duration: 2.5, ease: 'sine.inOut' }, 0)
  .to('.spotlight_2', { rotate: -15, duration: 2.5, ease: 'sine.inOut' }, 0)
  .to('.spotlight_1', { rotate: -15, duration: 2.5, ease: 'sine.inOut' }, '> ')
  .to('.spotlight_2', { rotate: 15, duration: 2.5, ease: 'sine.inOut' }, '<');

// Bulb scale handlers
function ScaleBulb2_up() {
  gsap.to(container_bulb_3, { duration: 0.5, scale: 1.4 });
}

function ScaleBulb2_down() {
  gsap.to(container_bulb_3, { duration: 0.5, scale: 1 });
}

// Hover listeners
container_bulb_3.addEventListener('mouseenter', () => {
  spotlightTween.play();
  ScaleBulb2_up();
});

container_bulb_3.addEventListener('mouseleave', () => {
  ScaleBulb2_down();
  
  // Pause the infinite loop and smoothly reset lights to vertical (0deg)
  spotlightTween.pause();
  gsap.to('.spotlight_1, .spotlight_2', {
    rotate: 0,
    duration: 1,
    ease: 'power2.out'
  });
});





// BEACH >>>>>>>>>>>>>>>>>>>

const card = document.querySelector('.lightbulb-clock');
const ball = document.getElementById('ball');

let isHovered = false;
let bounceAnimation = null;

function playBounce() {
  bounceAnimation = gsap.timeline({
    onComplete: () => {
      // If the cursor is still hovering when the bounce finishes, loop it again
      if (isHovered) {
        playBounce();
      }
    }
  });

  bounceAnimation
    .to(ball, {
      y: -120,
      duration: 0.35,
      ease: "power2.out",
    })
    .to(ball, {
      y: 0,
      duration: 0.75,
      ease: "bounce.out" // Real physics drop-and-bounce effect
    });
}

function scaleBulb3_on(){
  gsap.to(card, {
      scale: 1.4,
      duration: 1,
      ease: "power2.out"
    })
}
function scaleBulb3_off(){
  gsap.to(card, {
      scale: 1,
      duration: 1,
      ease: "power2.out"
    })
}


card.addEventListener('mouseenter', () => {
  isHovered = true;
  
  // If not currently bouncing, kick off the loop
  if (!bounceAnimation || !bounceAnimation.isActive()) {
    scaleBulb3_on();
    playBounce();
  }
});

card.addEventListener('mouseleave', () => {
  isHovered = false;
  scaleBulb3_off();
});







// >>>>>>>> END INTERACTIVE LIGHTBULBS















// xxxxxxxxxxxxxxxxxxxxxxxxxxx
// QUOTE SECTION
// xxxxxxxxxxxxxxxxxxxxxxxxxxx

// title Animation H3
const quotes = document.querySelectorAll(".services-details h3");
// presets
  quotes.forEach((quote) => {
    // Reset if needed
    if (quote.anim) {
      quote.anim.progress(1).kill();
      quote.split.revert();
    }

    quote.split = new SplitText(quote, {
      type: "lines,words,chars",
      linesClass: "split-line"
    });

    gsap.set(quote.split.chars, {opacity:1});

    // Set up the anim
    quote.anim = gsap.from(quote.split.chars, {
      scrollTrigger: {
        trigger: quote,
       // toggleActions: "restart pause resume reverse",
        start: "center center",
        end: "bottom+=1000px",
        markers: { startColor: "#dfdcff", endColor: "transparent" }
      },
      duration: 0.3,
      ease: "circ.out",
      opacity:0,
      blur: 4,
      stagger: 0.02
    });
  });



  // Calculator Outline Animation - for quote section at footer
// presets stroke to zero
gsap.set(".calc-outlines", {strokeWidth: 0});
gsap.set(".hourly-rate, .quote-link", {autoAlpha: 0});
gsap.set(".service-crd-1 h4", {autoAlpha: 0, y:"-20px"});
gsap.set(".service-crd-1 span", {autoAlpha: 0, x:"40px"});
gsap.set(".services-get-a-quote h2, .service-crd-2 p", {autoAlpha: 0, y:"20px"});
gsap.set(".service-crd-2 h4", {autoAlpha: 0, y:"-20px"});





let tl_qoute = gsap.timeline({
    scrollTrigger: {
      trigger: ".services-get-a-quote",
      start: "top center",
      //scrub: true,
     // end: "bottom+=2000px",
      markers: false
    }
  })
 .to(".services-get-a-quote h2", {duration: 1, y:"0px", autoAlpha:1, onStart:calculatorAnmt})
 .to(".service-crd-1 h4", {duration: 1, y:"0px", autoAlpha:1, delay:-0.75})
 .to(".service-crd-2 h4", {duration: 1, y:"0px", autoAlpha:1, delay:-1})
 .to(".service-crd-2 p", {duration: 1, y:"0px", autoAlpha:1, delay:-1.25})
 .to(".service-crd-1 span", {duration: 1.5, x:"0px", autoAlpha:1,  delay:-1.25})
 .to(".quote-link", {duration: 1.5, autoAlpha:1,  delay:-1});  // This is the moving h1 text behind monitor

 

 let tl_calc_lines = gsap.timeline({});

function calculatorAnmt(){
 tl_calc_lines
 .set(".calc-outlines", { opacity: 1, drawSVG: "0%", strokeWidth: 1, fill: "none", scale: 1, rotate: 0 })
 .to(".calc-outlines", { duration: 8, strokeWidth: 1, drawSVG: "100%",  autoAlpha:1 })
 .to(".hourly-rate", {autoAlpha:1, duration: 3, ease: "power4.out", delay:-8, onStart:herotxtfx});

 // SpliText FX
     let splitTitleQuote = new SplitText(".hourly-rate", {
      type: "words,chars"
    });

    let chars = splitTitleQuote.chars; //an array of all the divs that wrap each character

    function herotxtfx() {
      gsap.from(chars, {
        duration: 0.2,
        opacity: 0,
        y: 10,
        ease: "none",
        delay:1,
        stagger: {
          each: 0.05,
          from: "random"
        }
      });
    }  
}




}, { scope: bgfx_ref_5 }); 
   // End of useGSAP











   



  return (
  
<main className="page-content page-id_services" data-page-id="services" ref={bgfx_ref_5}>
<HelmetProvider> 
<Fragment> 
      <Helmet>
        <title>Services | MarkHawkinsDesigns.com</title>
        <meta name="description" content="Professional graphic designs and web development services by Mark Hawkins. Over 20 years experience. Hire me for your next project."/>
      
      </Helmet>
</Fragment>
</HelmetProvider> 

<svg version="1.1" className="services-transition-curtain transition-curtain" x="0px" y="0px"viewBox="0 0 191 191" xmlSpace="preserve">
<path className="st0" d="M95.5,190.5c-52.4,0-95-42.6-95-95s42.6-95,95-95s95,42.6,95,95S147.9,190.5,95.5,190.5z"/>
<path className="st1" d="M95.5,1C147.6,1,190,43.4,190,95.5S147.6,190,95.5,190S1,147.6,1,95.5S43.4,1,95.5,1 M95.5,0
	C42.8,0,0,42.8,0,95.5S42.8,191,95.5,191S191,148.2,191,95.5S148.2,0,95.5,0L95.5,0z"/>
</svg>








<div className="hero-container-wrap">   
<div className='hero-container'>
  <div className="hero-mask">

  <div className='mask-svg'>
    <svg viewBox="0 0 0 0" height="0" width="0">
      <defs> 
          <clipPath id="clipping" clipPathUnits="objectBoundingBox" transform="scale(0.00099, 0.00105)"> 
              <path id="dotmask" d="M853,0c0,357.9-290.1,648-648,648c-71.6,0-140.6-11.6-205-33.1v158.6C65.4,790.8,134.1,800,205,800
			c441.8,0,800-358.2,800-800H853z"/>
              <path id="hoopmask"  d="M0,0v501.1c63.2,25.9,132.4,40.2,205,40.2c298.9,0,541.3-242.3,541.3-541.3H0z"/>
	        </clipPath>
      </defs> 
    </svg>
  </div>
 



  { /* hero image SVG  */ } 
 <div className='heroimage'>



 <div className="cursorfx-wrapper">	
  <div className="cursorfx">
	<div id="cursorfx-1">	
 		 <span id="typing-text-1"> </span><span className="cursor">&#9616;</span>
	</div>
	<div id="cursorfx-2">	
  		<span id="typing-text-2"> </span><span className="cursor">&#9616;</span>
	</div>
	<div id="cursorfx-3">	
 		 <span id="typing-text-3"> </span><span className="cursor">&#9616;</span>
	</div>
  </div>	
</div>

<div className="arrow-wheel-wrap">
<svg version="1.1" viewBox="0 0 2400 1732" className="arrow-wheel-fx">
  <g id="arrow-wheel-1">
      <path className="arrow-wheel" d="M1971.1,769.7c-.2,181.6-148,329.3-329.6,329.3s-329.6-147.9-329.6-329.6,139.5-321.1,314.1-329.3v21l48.2-24.1-48.2-24.1v21c-39.9,1.8-78.5,10.5-115.2,26-40,16.9-75.9,41.1-106.7,72-30.8,30.8-55.1,66.8-72,106.7-17.5,41.4-26.4,85.4-26.4,130.7s8.9,89.3,26.4,130.7c16.9,40,41.1,75.9,72,106.7,30.8,30.8,66.8,55.1,106.7,72,41.4,17.5,85.4,26.4,130.7,26.4s89.3-8.9,130.7-26.4c40-16.9,75.9-41.1,106.7-72,30.8-30.8,55.1-66.8,72-106.7,17.5-41.3,26.3-85.1,26.4-130.3h-6.2Z"/>
      <rect className="arrow-wheel-spacer" x="1620.2" y="1104.2" width="5.8" height="21"/>
    </g>
  <g id="arrow-wheel-2">
      <path className="arrow-wheel" d="M776.9,866.6c-.2,153.5-125.1,278.4-278.7,278.4s-278.7-125-278.7-278.7,118-271.5,265.6-278.4v17.8l40.8-20.4-40.8-20.4v17.8c-33.7,1.5-66.4,8.9-97.4,22-33.8,14.3-64.2,34.8-90.2,60.8-26.1,26.1-46.5,56.4-60.8,90.3-14.8,35-22.3,72.2-22.3,110.5s7.5,75.5,22.3,110.5c14.3,33.8,34.8,64.2,60.8,90.3,26.1,26.1,56.4,46.5,90.2,60.8,35,14.8,72.2,22.3,110.5,22.3s75.5-7.5,110.5-22.3c33.8-14.3,64.2-34.8,90.2-60.8,26.1-26.1,46.5-56.4,60.8-90.3,14.8-34.9,22.3-72,22.3-110.2h-5.2Z"/>
      <rect className="arrow-wheel-spacer" x="480.2" y="1149.4" width="4.9" height="17.8"/>
    </g>
    <g id="arrow-wheel-3">
      <path className="arrow-wheel" d="M874.9,262.6h-3.9c0,28.5,5.7,56.2,16.7,82.3,10.7,25.2,26,47.9,45.5,67.4,19.5,19.5,42.1,34.8,67.4,45.5,26.2,11.1,53.9,16.7,82.6,16.7s56.4-5.6,82.6-16.7c25.2-10.7,47.9-26,67.4-45.5,19.5-19.5,34.8-42.1,45.5-67.4,11.1-26.2,16.7-53.9,16.7-82.6s-5.6-56.4-16.7-82.6c-10.7-25.2-26-47.9-45.5-67.4-19.5-19.5-42.1-34.8-67.4-45.5-23.2-9.7-47.6-15.3-72.8-16.4v-13.3s-30.5,15.2-30.5,15.2l30.5,15.2v-13.3c110.3,5.1,198.4,93.2,198.4,208,0,114.8-93.5,208.2-208.2,208.2s-208.1-93.3-208.2-208v.2Z"/>
      <rect className="arrow-wheel-spacer" x="1069.7" y="473.7" width="3.7" height="13.3"/>
    </g>
</svg>
</div>

    { /* hero image  */ } 
      <img src={heroimg_services} alt="Services background hero - picture of gears in a clock closeup"  />
    </div> 
  </div>

  <div className='hero-text'>
    <div className="page-h1">
     <h1 style={{ opacity: 0, visibility: 'hidden' }}>Services</h1>
     <div className="h1-accent"><span></span></div>
    </div>
    <strong>Graphic Design &amp; Web Development</strong>
  </div>

</div>
</div>  












<div className="content">

<section className="web-development-services"> 
  <div className="columns">
      <div className="col-50">
        <div className="wd-content">
          <h2>Web Development</h2>


      <div className="wd-content-1">
          <p className="wd-p1">Specializing in end-to-end design and development for robust corporate and e-commerce platforms, leveraging the power of WordPress, WooCommerce, and Shopify. My process is built on two decades of experience, fusing critical elements—SEO, Usability, Marketing insight, and innovative Design—to produce websites that guarantee maximum brand impact, increased market exposure, and effortless maintenance.</p>
     </div>  
     <div className="wd-content-2">


 <div className="services-details">
   

    <div className="columns">
      <div className="col-50">
          <ul className="wd-ul-1">
            <li>
              <span data-toggle="tooltip" role="tooltip">Custom Theme Design</span>
            </li>
            <li>
              <span>ADA Compliance Design</span>
            </li>
            <li>
              <span>4<sup>+</sup> Web Page Site</span>
            </li>
            <li>
              <span>up to 7 Design Revisions</span>
              </li>
            <li>
              <span>Home Page & Layout Proofs</span>
              </li>
                    <li>
            <span>1-2 Hour Consultation</span>
             </li>
          <li>
            <span>Mobile Optimization</span>
          </li>
          <li>
            <span>Keyword Discovery</span>
          </li>
          </ul>
      </div>

     <div className="col-50">
        <ul className="wd-ul-2">
          <li>
            <span>Custom Home Page Hero</span>
            </li>
          <li>
            <span>5<sup>+</sup> iStock Images</span>
            </li>
          <li>
            <span>Email Contact Form</span>
          </li>
          <li>
        <span>Creation of 2<sup>+</sup> Email Accounts</span>
       </li> 
          <li>
            <span>Site Blog</span>
            </li>
             
          <li>
            <span>Search Engine Optimzation</span>
           </li>
          <li>
            <span>W3 Certified Testing</span>
           </li>
      </ul>
     </div>

  
    </div>
</div>
 
    </div> 
 </div>

 

  </div>
    <div className="col-50"> 


<div className="services-wd-image-wrap">
      <img className="wd-img" src={services_img_1} alt="Graphic Design Services" /> 
</div>


      </div>
  </div>

 

</section>






<hr className="services-hr" />




<section className="graphic-design-services"> 
<div className="columns services-details">

  <div className="col-50">
    

	  <div className="graphic-design-services-hero">
		  <div className="lightbulb-lighthouse">
         <div className="lightbulb">
		          <div className="back"><img src={lightbulb_1_back} alt="Lighbulb Lighthouse Back" /></div>
			        <div className="middle"><img src={lightbulb_1_light} alt="Lightbulb Lighthouse Light" /></div>
			        <div className="front"><img src={lightbulb_1_front} alt="Lightbulb Lighthouse Front" /></div>
         </div>
		  </div>
      	 <div className="lightbulb-city-ufo">
          <div className="lightbulb">
		          <div className="back"><img src={lightbulb_2_back} alt="Graphic Design Services" /></div>
			        <div className="middle">

<svg viewBox="0 0 1179 2172" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <style>
      {`
      .spotlight_1 { fill: url(#linear-gradient_a); }
      .spotlight_2 { fill: url(#linear-gradient_b); }
    `}
    </style>
    <linearGradient id="linear-gradient_b" x1="470.6" y1="902.5" x2="376" y2="287.8" gradientTransform="translate(56.8 -32.3) rotate(3.6)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#ffffff" stopOpacity="0.3" />
      <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
    </linearGradient>

    <linearGradient id="linear-gradient_a" x1="213.6" y1="902.5" x2="119" y2="287.8" gradientTransform="translate(869.8 19.5) rotate(-176.4) scale(1 -1)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#ffffff" stopOpacity="0.3" />
      <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
    </linearGradient>
  </defs>

  <g id="search-lights">
    <polygon className="spotlight_2"  points="514.2 1592.3 393.9 418.5 468.2 413.2 514.2 1592.3"/>
    <polygon className="spotlight_1" points="516.5 1592.5 784.8 443.4 711.8 428.8 516.5 1592.5"/>
  </g>
</svg>


              </div>
			        <div className="front"><img src={lightbulb_2_front} alt="Graphic Design Services" /></div>
        </div>
	  	</div>
	  	<div className="lightbulb-clock">
         <div className="lightbulb">
		         <div className="back"><img src={lightbulb_3_back} alt="Graphic Design Services" /></div>
			       <div className="middle"></div>
			       <div className="front"><img src={lightbulb_3_front} alt="Graphic Design Services" /></div>

             <div className="beach_ball"> 

<svg version="1.1" viewBox="0 0 1204 2206">
<defs>
     <radialGradient id="radial-gradient" cx="387.5" cy="1189.1" fx="387.5" fy="1189.1" r="238.4" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#fff"/>
      <stop offset=".3" stopColor="#fbfbfb"/>
      <stop offset=".9" stopColor="#999"/>
    </radialGradient>
    <linearGradient id="linear-gradient" x1="387.3" y1="1168.3" x2="521.2" y2="1298.4" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#fff53f"/>
      <stop offset="1" stopColor="#bc741e"/>
    </linearGradient>
    <linearGradient id="linear-gradient1" x1="329.7" y1="1102.9" x2="452.5" y2="1102.9" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#29abe2"/>
      <stop offset="1" stopColor="#9fdaff"/>
    </linearGradient>
    <linearGradient id="linear-gradient2" x1="275.7" y1="1237.4" x2="320.9" y2="1227.1" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#c1272d"/>
      <stop offset="1" stopColor="#ff7bac"/>
    </linearGradient>
  </defs>

<g id="ball">

    <circle className="ball_bg"  cx="407.6" cy="1211.2" r="136" fill="#ffffff" />
    
    
    <path className="stx" fill="#ff4d4d" d="M469.1,1172.2c-50.5-16.5-80.8-19.2-92.4-19.5,0,7.6-2.2,15.7-6.8,23.2-3.6,5.7-8.1,10.3-13.1,13.6,5.7,13.9,18.2,42.1,38.1,75.5,27.6,49.9,66.8,71.3,66.8,71.3,0,0,40.1-18.1,59-48.7,19-30.6,22.8-66.4,22.8-66.4,0,0-15.8-29.9-74.4-49.1Z"/>
    
    
    <path className="st2" fill="#4d94ff" d="M389.4,1076.5c-34.4,5.8-56.1,20.7-56.1,20.7,0,0-3.6,6.9-3.6,14s3.1,18.5,3.5,20c8.9-5.8,19.1-7.6,27.7-4.2,3.3-3.1,22.8-21.2,36.2-29.8,22.6-14.3,55.3-14.3,55.3-14.3,0,0-31.6-12.9-63.1-6.4Z"/>
    
  
    <path className="st5" fill="#ffd11a" d="M304.5,1217.9c4.5-16.4,10.1-27.2,13.6-32.9-4.7-7.1-6.1-16.7-3.8-26.5-4,.5-11.8,1.7-19.4,4.1-10.9,3.6-17.6,9.7-17.6,9.7,0,0-10,26.4-3.1,65.2,6,33.6,31.5,63.7,31.5,63.7,0,0-17.4-25.1-1.3-83.4Z"/>

</g>
  <g id="bulb_border">
    <ellipse className="st1" id="border-path" cx="604" cy="670.6" rx="528.3" ry="614.9"/>
  </g>
</svg>


             </div>
             <div className="lightbulb-boundingbox"></div>
        </div>
		  </div>


<div className="graphic-design-services-bg">
       <img src={graphic_design_section_bg} alt="Graphic Design Services" />
</div>



	  </div>
  </div>
  <div className="col-50">
  
  <div className="gd-content">
    <h2>Graphic Design</h2>


<div className="gd-content-1">
    <p className="gd-p1">Infusing creative marketing and branding designs that powerfully communicate your unique qualities and differences about your business, services or products. Whether you need compelling hand-drawn illustrations and icons, stunning packaging design, or detailed product label designs, I have the proven expertise to cover all your graphic design needs.</p>
   </div>
   
<div className="gd-content-2">
     <div className="services-details">

    <div className="columns">
      <div className="col-50">
          <ul className="gd-ul-1">
            <li>
              <span>Logos</span>
            </li>
            <li>
              <span>Icons</span>
            </li>
             <li>
              <span>Illustrations</span>
            </li>
             <li>
              <span>User Interface</span>
            </li>
            <li>
              <span>Cartoons</span>
            </li>
                 <li>
            <span>Product Labels</span>
          </li>
          <li>
            <span>Product Manuals</span>
          </li>
          </ul>
      </div>

     <div className="col-50">
        <ul className="gd-ul-2">
          <li>
            <span>Business Cards</span>
            </li>
          <li>
            <span>Flyers</span>
            </li>
          <li>
            <span>Brochures</span>
            </li> 
             <li>
              <span>Posters</span>
            </li> 
            <li>
              <span>Infographics</span>
            </li>  
             
                  <li>
            <span>Banners</span>
          </li>
             <li>
              <span>Stickers</span>
            </li> 
      </ul>
     </div>
</div>
 

    </div>
</div>

   
   
    </div>
     </div>
</div>




</section>





<section className="services-details services-get-a-quote">
  <h2>Request a Quote</h2>
  <div className="rate-and-quote-grid">
    <div className="col-1">
      <div className="border-container service-crd-1">
      <h4>Hourly Rate</h4>
      <strong className="hourly-rate">$100</strong>
      <span>*quotes are based on hourly rate</span>
       </div>
    </div> 

     <div className="col-2">
          <svg version="1.1" viewBox="0 0 84 99.3" className="quote-icon">
                 <path className="calc-outlines" d="M74.1,1.1H9.9C4.9,1.1.9,5.1.9,10.1v79.1c0,5,4,9,9,9h64.2c5,0,9-4,9-9V10.1c0-5-4-9-9-9ZM20.7,88.7c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM20.7,73c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM20.7,57.3c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM37.3,88.7c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM37.3,73c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM37.3,57.3c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM53.9,88.7c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM53.9,73c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM53.9,57.3c0,1.1-.9,2-2,2h-6.7c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h6.7c1.1,0,2,.9,2,2v6.7ZM74.6,88.7c0,1.1-.9,2-2,2h-8.8c-1.1,0-2-.9-2-2v-6.7c0-1.1.9-2,2-2h8.8c1.1,0,2,.9,2,2v6.7ZM74.6,72.4c0,1.4-1.2,2.5-2.5,2.5h-7.8c-1.4,0-2.5-1.2-2.5-2.5v-21.2c0-1.4,1.2-2.5,2.5-2.5h7.8c1.4,0,2.5,1.2,2.5,2.5v21.2ZM74.9,35.8c0,3.6-2.9,6.6-6.6,6.6H15.6c-3.6,0-6.6-2.9-6.6-6.6v-19.5c0-3.6,2.9-6.6,6.6-6.6h52.7c3.6,0,6.6,2.9,6.6,6.6v19.5Z"/>
                 </svg>
     </div>

     <div className="col-3">
     <div className="border-container service-crd-2">
      <h4>Let's Discuss Your Project</h4>
      <p>Receive an accurate, transparent proposal within 48 hours.</p>
       <button className="colorborderfx quote-link">
        <NavLink  to="/contact"> <span className="button_label_wd">Contact Me</span> <span className="button_services_arrow"></span></NavLink>
       </button>



        </div>
    </div>
  </div>


</section>





</div>
</main>
  );
};

export default Services;